import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ReportsService } from 'src/app/services/reports.service';

// Plain, report-specific filter payload - built by dbtdistrictwiseflowprogressreport.component.ts's
// own filter form. *IdValue fields are display-only strings for the RDLC page header
// (Scheme/Component/FinancialYear/Community/G.O banner), resolved by the parent from its
// own already-loaded lookup lists - see LotteryReportPopupData for the identical convention.
export interface DbtDistrictWiseFlowProgressReportPopupData {
  financialyearId: number;
  financialyearIdvalue: string;
  departmentId: number;
  goId: number;
  goIdvalue: string;
  schemeId: number;
  schemeIdvalue: string;
  componentId: number;
  componentIdvalue: string;
  community: number;
  communityvalue: string;
}

@Component({
  selector: 'app-dbtdistrictwiseflowprogressreportpopup',
  templateUrl: './dbtdistrictwiseflowprogressreportpopup.component.html',
  styleUrls: ['./dbtdistrictwiseflowprogressreportpopup.component.scss']
})
export class DbtDistrictWiseFlowProgressReportPopupComponent implements OnInit {

  loading = false;
  reportHtml: SafeHtml | null = null;

  constructor(
    public dialogRef: MatDialogRef<DbtDistrictWiseFlowProgressReportPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DbtDistrictWiseFlowProgressReportPopupData,
    private reportsService: ReportsService,
    private sanitizer: DomSanitizer
  ) { }

  // On-screen preview = the same RDLC-rendered Html downloadexcel() would otherwise
  // produce as Excel (downloadType 4 = Html) - same pattern as LotteryReportPopupComponent.
  ngOnInit(): void {
    this.loading = true;
    this.reportsService.dbtDistrictWiseFlowProgressReport(this.reportRequest(4)).subscribe((result: string) => {
      this.reportHtml = result ? this.sanitizer.bypassSecurityTrustHtml(atob(result)) : null;
      this.loading = false;
    }, () => {
      this.reportHtml = null;
      this.loading = false;
    });
  }

  private get fileNameBase(): string {
    return 'District Wise Progress Report' + (this.data?.financialyearIdvalue ? ' - ' + this.data.financialyearIdvalue : '');
  }

  // ------ Backed by ReportType.DBTDistrictWiseFlowProgressReport (67) ->
  // ReportController.LoadReportByType -> Rdlc/DBTDistrictWiseFlowProgressReport.rdlc,
  // via ReportsService.dbtDistrictWiseFlowProgressReport() - maps this popup's own
  // filter fields onto ReportSearchViewModel's field names (same shape every other
  // RDLC-backed report screen in this app uses).
  private reportRequest(downloadType: number): any {
    return {
      financialyearId: this.data.financialyearId,
      financialyearIdvalue: this.data.financialyearIdvalue,
      departmentId: this.data.departmentId,
      GoId: this.data.goId,
      goIdvalue: this.data.goIdvalue,
      schemeId: this.data.schemeId,
      schemeIdvalue: this.data.schemeIdvalue,
      componentId: this.data.componentId,
      componentIdvalue: this.data.componentIdvalue,
      community: this.data.community,
      communityvalue: this.data.communityvalue,
      ReportType: 67,
      downloadType
    };
  }

  downloadexcel(): void {
    this.reportsService.dbtDistrictWiseFlowProgressReport(this.reportRequest(2)).subscribe((result: string) => {
      if (!result) {
        return;
      }
      const downloadLink = document.createElement('a');
      downloadLink.href = 'data:application/vnd.ms-excel;base64, ' + result;
      downloadLink.download = this.fileNameBase + '.xls';
      downloadLink.click();
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
